export default "__VITE_ASSET__C25bUeFL__"